<ui-panel-header
  [panelHeaderConfig]="panelHeaderConfig"
  [legendItems]="legendItems"
>
</ui-panel-header>
